import {Link} from "react-router";
import {Col, Row} from "../../components/Flex/Flex";
import Page from "../../components/Page/Page";


export default function CreditsPage() {

    return (
        <Page className="line-height-3">
            <title>Credits</title>
            <Row align="center">
                <Col><Link to="/"><img className="credits-logo" src="/logo.png" title="The Forge" alt="The Forge Logo"/></Link></Col>
                <Col>
                    <h1 className="m-0">The Forge</h1>
                </Col>
            </Row>


            <p className="credits">
                Created and maintained by <b>Kaire Nat-Sa</b><br />
                With moral and coding support by <b>Farin Simarca</b><br />
                Initially inspired by PISTON, made by Vadik Edik<br />
            </p>
            <h3>Coding</h3>
            Discord Timestamp calculation based on <a href="https://github.com/DJDavid98/HammerTime" target="_blank" rel="noreferrer">https://github.com/DJDavid98/HammerTime</a><br />
            Powered by the <a href="https://gitlab.com/kaire.natsa/swc-api/-/wikis/home" target="_blank" rel="noreferrer">swc-api</a> project<br />
            UI Framework: <a href="https://mantine.dev/" target="_blank" rel="noreferrer">Mantine</a><br />
            Server Management: <a href="https://coolify.io/" target="_blank" rel="noreferrer">Coolify</a><br />
            Icon Package: <a href="https://phosphoricons.com/" target="_blank" rel="noreferrer">Phosphor Icons</a><br />

            <h3>Assets</h3>
            Logo created by  <a href="https://www.flaticon.com/free-icons/anvil" title="anvil icons" target="_blank" rel="noreferrer">Assia Benkerroum - Flaticon</a><br />
            Custom icons designed by <b>Bork Shalas</b>

        </Page>
    )
}
